import React, { Fragment } from 'preact/compat';
import { ProductOptions } from './types';

export function ProductMenuOptions({ options }: ProductMenuOptionsProps) {
    return (
        <Fragment>
            {Object.entries(options).map(([key, value]) => {
                if (typeof value === 'string') {
                    return (
                        <option key={key} value={key}>{value}</option>
                    );
                }

                return (
                    <optgroup key={key} label={key}>
                        <ProductMenuOptions options={value} />
                    </optgroup>
                );
            })}
        </Fragment>
    );
}

type ProductMenuOptionsProps = {
    options: ProductOptions,
}
